import React from 'react';
import close from "../../../images/close.svg";
import {useTheme} from "../../../App";
import {useTranslation} from "react-i18next";

const HideTrips = ({closeModal, onSubmit}) => {
  const {t} = useTranslation()
  const {isDark} = useTheme()
  return (
    <div style={{width: '480px'}} className={`modal ${isDark && 'modal__dark'}`}>
      <h5 className="modal__mainTitle mr-30">{t('hideTrips')}</h5>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <p className="modal__text mr-30">{t('isHideTrips')}</p>
      <div className="modal__buttons">
        <div className="modal__actions">
          <button onClick={onSubmit} className="submit-button">
            {t('confirmHide')}
          </button>
          <button onClick={closeModal} className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
            <span className="commonBtn__label">{t('notHide')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(HideTrips);
